"use client"

import { useState } from "react"
import { useTranslations } from "next-intl"

const NewsletterSection = () => {
  const t = useTranslations('Newsletter')
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle")

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return

    setStatus("loading")

    // Simulate API request
    setTimeout(() => {
      setStatus("success")
      setEmail("")
      
      // Reset success status after a few seconds
      setTimeout(() => setStatus("idle"), 3000)
    }, 1000)
  }

  return (
    <section className="relative z-10 w-full overflow-hidden pb-12 pt-8">


      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.02] backdrop-blur-md p-8 md:p-12">
          
          {/* Inner Glow Line */}
          <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-purple-500/50 to-transparent" />
          
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-akira text-white mb-3 tracking-wide">
                {t('title')}
              </h2>
              <p className="text-gray-400 font-poppins text-sm md:text-base max-w-md">
                {t('subtitle')}
              </p>
            </div>

            <div className="w-full md:w-auto flex-1 max-w-xl">
              <form onSubmit={handleSubmit} className="relative flex items-center w-full">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('placeholder')}
                  disabled={status === "loading" || status === "success"}
                  className="w-full bg-[#0a0512]/50 border border-white/10 rounded-full py-3.5 pl-6 pr-40 text-white font-poppins text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500/50 transition-all disabled:opacity-50"
                  required
                />
                <button
                  type="submit"
                  disabled={status === "loading" || status === "success"}
                  className="absolute right-1.5 top-1.5 bottom-1.5 bg-purple-600 hover:bg-purple-500 text-white font-poppins font-medium text-sm px-6 rounded-full transition-all duration-300 disabled:opacity-80 flex items-center justify-center min-w-[120px]"
                >
                  {status === "loading" ? (
                    <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : status === "success" ? (
                    <span className="flex items-center gap-1.5">
                      <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {t('success')}
                    </span>
                  ) : (
                    t('button')
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NewsletterSection
